import { ComponentStyleConfig } from '@chakra-ui/react'

const textStyles = {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '150%',
    color: 'light.tones.navy'
}

export const LabelStyles: ComponentStyleConfig = {
    baseStyle: {
        text: {
            ...textStyles,
            fontWeight: 500
        },
        supportingText: {
            ...textStyles,
            color: 'light.tones.stormGrey'
        },
        icon: {
            width: '10px',
            height: '10px',
            color: 'light.tones.stormGrey'
        }
    }
}
